import { AlertStyle } from "../js/enums";
import {
  RENEWAL_WARNING_MINUTES,
  useRenewalDue,
} from "../js/session";
import Alert from "./elements/Alert";

function SessionRenewal() {
  const renewalDue = useRenewalDue();

  if (!renewalDue) {
    return <></>;
  }

  return (
    <Alert style={AlertStyle.Warning} className="mb-3">
      <div className="d-flex align-items-center justify-content-between gap-3">
        <div>
          <strong>
            Your session is due to expire in{" "}
            {RENEWAL_WARNING_MINUTES} minutes
          </strong>
          <p className="mb-0">
            Please review and save your work, then sign in again to
            continue
          </p>
        </div>
        <a
          href="/renew"
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-warning text-nowrap"
        >
          Sign in again
        </a>
      </div>
    </Alert>
  );
}

export default SessionRenewal;
